import AccountDetails from './account-details';

export default AccountDetails;
